import { create } from 'zustand';
import type { SupportTicket } from '@spawnwire/shared';
import { errorMessage, http } from '../../lib/api';

/** Your support tickets, for the Support page and the sidebar's new-reply badge. */
export const useSupport = create<{ tickets: SupportTicket[] | null; error: string | null }>(() => ({ tickets: null, error: null }));

/** A ticket without its conversation, as the list keeps it. */
function summary(ticket: SupportTicket): SupportTicket {
  const { messages: _messages, ...rest } = ticket as SupportTicket & { messages?: unknown };
  return rest;
}

export const support = {
  async load(): Promise<void> {
    try {
      useSupport.setState({ tickets: await http.get<SupportTicket[]>('/support/tickets'), error: null });
    } catch (err) {
      useSupport.setState({ error: errorMessage(err) });
    }
  },
  /** A ticket changed: staff replied (over the socket), or you did something to it. */
  upsert(ticket: SupportTicket): void {
    const { tickets } = useSupport.getState();
    if (!tickets) return;
    const next = [summary(ticket), ...tickets.filter((t) => t.id !== ticket.id)].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
    useSupport.setState({ tickets: next });
  },
};
